const aFramePropertyString = function(object) {
    let string = '';
    for (const [key, value] of Object.entries(object)) {
        string+= key + ': ' + value + ';';
    }
    return string;
}

export {aFramePropertyString};